// What the email link that opened this tab was for.
//
// A password reset or a team invite arrives as
// index.html#access_token=…&type=recovery (or type=invite). supabase-js signs
// the person in from those tokens and then WIPES the #… part, so by the time
// any module runs, nothing says the person still has to choose a password.
// index.html's first inline script (id="auth-link-capture") copies the link's
// purpose into sessionStorage before supabase-js loads; this module is the one
// place that reads it.
//
// ⚠️ sessionStorage, NOT A VARIABLE: it survives a reload of the same tab, so
// a person who refreshes before saving is still asked (modules/password.js).
// It ends with the tab, so it never follows them anywhere else.
//
// An expired or already-used link arrives as #error_code=… with no sign-in,
// and the sign-in page says so (login.js).

export const LINK_KEY = 'revfit_auth_link';
export const LINK_ERROR_KEY = 'revfit_auth_link_error';

/** 'recovery' or 'invite' while a link's new password is still owed, else null. */
export function linkNeedsPassword() {
  try {
    const v = sessionStorage.getItem(LINK_KEY);
    return v === 'recovery' || v === 'invite' ? v : null;
  } catch { return null; }
}

/** The password is chosen (or the person signed out): stop asking. */
export function passwordNoLongerOwed() {
  try { sessionStorage.removeItem(LINK_KEY); } catch { /* storage blocked: nothing to clear */ }
}

/** Was this tab opened by a link that had expired or was already used? Reads it once. */
export function takeLinkError() {
  try {
    const v = sessionStorage.getItem(LINK_ERROR_KEY);
    sessionStorage.removeItem(LINK_ERROR_KEY);
    return !!v;
  } catch { return false; }
}
